import script from "./DirectionList.vue?vue&type=script&lang=ts&setup=true"
export * from "./DirectionList.vue?vue&type=script&lang=ts&setup=true"

import "./DirectionList.vue?vue&type=style&index=0&id=8cfb5280&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cfb5280"]])

export default __exports__